import { observer } from "mobx-react";
import * as React from "react";

export interface IResultSetSizeButtonProps {
	onClick?: React.EventHandler<React.MouseEvent<any>>;
	label?: string;
	testId?: string;
	removeHover?: boolean;
}

@observer
export class ResultSetSizeButton extends React.Component<IResultSetSizeButtonProps, {}> {
	render() {
		let label: any = this.props.label ? <span>{this.props.label}</span> : null;

		return <button onClick={this.props.onClick} className={"button-resultset-size" + (this.props.removeHover ? " no-hover" : "")} data-test-id={this.props.testId}>
			{label}
		</button>;
	}
}